var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.left? 'float-left' : 'float-right'},[_c('v-avatar',{class:_vm.left? 'mr-3' : 'ml-3'},[_c('img',{attrs:{"src":_vm.avatarURL}})])],1),(_vm.showName)?_c('p',{staticClass:"headline pt-2"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }